import Decimal from "decimal.js";
import { BinanceRates } from "../binancerates.model";
import { AssetPurchase } from "../assetpurchase.model";
import { DepositRegister } from "../depositregister";
import { Asset } from "../assets.model";
import { User } from "../user.model";
import { System } from "../system.model";

// pre

type AssetPurchasesData = Pick<AssetPurchase, "assetId" | "quantity" | "amount" | "date" | "exchange_rate"> & {
    asset: Pick<Asset, "name" | "code" | "apiId">;
};

export type PreparedData = {
    depositRegisterData: Pick<DepositRegister, "id" | "amount_in_trade" | "liquidity" | "date" | "deduction_all" | "deduction_mining" | "deduction_physical_gold" | "deduction_alt" | "cost_deduction" | "fee"> | null;
    assetPurchasesData: AssetPurchasesData[];
    binanceRates: Map<number, Omit<BinanceRates, "id" | "asset">[]>;
}

// common

export const RecordType = {
    SIMPLE_TRANSACTION: 0,
    INVESTMENT_TRANSACTION: 1,
    FROM_GOLD: 2,
};

export type Transaction = {
    date: Date;
    amount: Decimal;
    quantity: Decimal;
    binanceRateRecord: Omit<BinanceRates, "id" | "asset" | "assetId">;
    recordType: number;
    executionPrice: Decimal;
};

export interface TopListElement {
    id: number;
    date: Date;

    userId: number;
    user: Pick<User, "user_id" | "name">;

    systemId: number;
    system: System;

    depositRegisterId: number;
    depositRegister: Pick<DepositRegister, "id">;

    investedAmountEur: number;
    investedAmountUsd: number;
    remainingPortfolioAssets: number;
    totalValue: number;

    altCoins: number;

    rate: Decimal;

    payoutDate: Date;
    payoutAmount: number;

    bitcoinPrice: number;
    ethereumPrice: number;
    bitcoinExchangeRate: number;
    ethereumExchangeRate: number;
    expectedBitcoinExchangeRate: number;
    expectedEthereumExchangeRate: number;

    created: Date;

};

export type TopListElementWithoutMeta = Omit<TopListElement, 'id' | 'system' | 'depositRegister' | 'created'>;






